declare global {
  interface Window {
    attachEvent?: (event: string, callback: () => void) => void;
  }
}

export const canUseDOM = !!(
  typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
);

export const canUseEventListeners = canUseDOM && !!(window.addEventListener || window.attachEvent);

export const canUseViewport = canUseDOM && !!window.screen;

export const canUseShortcuts = canUseDOM && !!window.navigator;

export const canUseImage =
  canUseDOM &&
  canUseEventListeners &&
  (() => {
    try {
      return !!window.Image && typeof window.Image === 'function';
    } catch {
      return false;
    }
  })();

export const canUseFetch = canUseDOM && !!window.fetch;
